// extracted by mini-css-extract-plugin
export var formContainer = "_mu-0";
export var message = "_mu-1";